__turbopack_context__.v({
  "contentWrapper": "JFoKLG_contentWrapper",
  "wrapper": "JFoKLG_wrapper",
});
